<template>
    <div>
        <v-dialog v-model="shownRelay" fullscreen>
            <v-card class="fill-height d-flex flex-column of-y">
                <div class="px-3 text-h6 white--text primary d-flex align-center justify-space-between" >
                    <div class="py-2">
                        Search All Recruitments
                    </div>

                    <div class="d-flex align-center">
                        <v-text-field
                                style="min-width: 400px"
                                hide-details
                                dense
                                flat
                                background-color="primary"
                                color="white"
                                dark
                                prepend-icon="mdi-magnify"
                                placeholder="Search Here"
                                persistent-placeholder
                                :loading="searching"
                                :disabled="searching"
                                ref="searchBar"
                                v-model="searchStr"
                                @keydown.enter="search"
                        >
                        </v-text-field>
                        <v-btn
                                outlined
                                color="white"
                                small
                                class="ml-2"
                                :loading="searching"
                                :disabled="searching"
                                @click="search"
                        >
                            Search
                        </v-btn>
                    </div>

                    <div>
                        <v-btn
                                icon
                                color="white"
                                @click="shownRelay = false"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>

                </div>
                <div class="flex-grow-1 fill-height of-y">
                    <v-data-table
                            v-if="!searching"
                            dense
                            fixed-header
                            height="100%"
                            class="fill-height of-y"
                            hide-default-footer
                            :headers="headers"
                            :items="results"
                            :options="{itemsPerPage: results.length}"
                            sort-by="captured"
                            :sort-desc="true"
                            ref="recruitmentsTable"
                            :calculate-widths="true"
                            @click:row="gotoRecruitment"
                    >
                        <template v-slot:item.captured="{item}">
                            {{ format(new Date(item.captured), 'yyyy-MM-dd') }}
                        </template>
<!--                        <template v-slot:item.captured="{item}">-->
<!--                            <span v-text="format(new Date(item.captured), 'yy-MM-dd HH:mm')" style="white-space: nowrap"/>-->
<!--                        </template>-->
<!--                        <template v-slot:item.clockNo="{item}">-->
<!--                            <template v-if="item.name && (item.idNo || item.passportNumber)">-->
<!--                                {{ item.clockNo }}-->
<!--                            </template>-->
<!--                            <template v-else>-->
<!--                                <v-btn-->
<!--                                        small-->
<!--                                        text-->
<!--                                        color="amber darken-1"-->
<!--                                >Unprocessed</v-btn>-->
<!--                            </template>-->
<!--                        </template>-->
                    </v-data-table>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {format} from "date-fns";

export default {
    props: {
        shown: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            format: format,
            results: [],
            searching: false,
            searchStr: null,
            headers: [
                {text: "Group", value: "groupDescription"},
                {text: "Contract", value: "contractDescription"},
                {text: "Captured", value: "captured"},
                {text: "Clock No", value: "clockNo"},
                {text: "Surname", value: "surname"},
                {text: "Name", value: "name"},
                {text: "Gender", value: "gender"},
                {text: "Position", value: "position"},
                {text: "IdNo", value: "idNo"},
                {text: "Passport Number", value: "passportNumber"},
                {text: "Nationality", value: "nationality"},
                {text: "Asylum Expiry", value: "asylumExpiry"},
                {text: "DOB", value: "dob"},
                {text: "Address", value: "address"},
                {text: "Next of Kin", value: "nextOfKin"},
                {text: "Next of Kin Cell", value: "nextOfKinCell"},
                {text: "Tax No", value: "taxNo"},
                {text: "Cell No", value: "cellNo"},
                {text: "Size", value: "size"},
                {text: "Bank Name", value: "bankName"},
                {text: "Acc Holder", value: "accHolder"},
                {text: "Branch", value: "branch"},
                {text: "AccNo", value: "accNo"},
            ],
        }
    },
    watch: {
        shown: {
            immediate: true,
            handler(val) {
                if (val) {
                    setTimeout(() => {
                        this.$refs.searchBar.focus()
                    }, 500)
                }


            }
        }
    },
    methods: {
        async search() {
            try {
                this.searching = true;
                this.results = [];
                const results = await this.$newReq('GET', `recruitment/groups/fullSearch/${this.searchStr}`)
                this.results = results
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                this.searching = false;
            }
        },
        gotoRecruitment(ev) {
            this.$emit('gotoRecruitment', {id: ev.id, fkRecruitmentGroup: ev.fkRecruitmentGroup})
            console.log({ev})
        }
    },
    computed: {
        shownRelay: {
            get() {
                return this.shown
            },
            set(val) {
                this.$emit('update:shown', val)
            }
        }
    },
}
</script>

<style scoped>

</style>